<div class="boolean">
  <ion-row class="yes-no">
    <ion-col size="3">
      <ion-button (click)="rate=10;didRated.emit(10);changeResponseStatus('positive')" expand="block"
        fill="{{rate === 10 ? 'solid': 'outline'}}" shape="round">
        {{'Yes' | translate}}
      </ion-button>
    </ion-col>
    <ion-col size="3">
      <ion-button (click)="rate=1;didRated.emit(1);changeResponseStatus('negative') " expand="block"
        fill="{{rate === 1 ? 'solid': 'outline'}}" shape="round">
        {{'No' | translate}}
      </ion-button>
    </ion-col>

  </ion-row>
  <ion-row *ngIf="question.answer">

    <ion-col size="12">
      <ion-label *ngIf="rate==10">
        <h2>
          {{question.positive_response_question | caption}}
        </h2>
      </ion-label>
      <ion-label *ngIf="rate==1">
        <h2>
          {{question.negative_response_question | caption}}
        </h2>
      </ion-label>
    </ion-col>
    <ion-col size="12">
      <ion-list>
        <ng-container *ngIf="option?.is_multiple;else single">

          <ion-item lines="none" *ngFor="let opt of option?.options; let i = index">
            <ion-label>
              <h5>{{opt | caption}}</h5>
            </ion-label>
            <ion-checkbox (ionChange)="selectedOptionsChanged(opt,'multiple')" slot="end" value="{{opt}}">
            </ion-checkbox>
          </ion-item>

        </ng-container>
        <ng-template #single>


          <ion-radio-group value="{{option?.options[0]}}">
            <ion-item lines="none" *ngFor="let opt of option?.options">
              <ion-label>
                <h5>{{opt | caption}}</h5>
              </ion-label>
              <ion-radio (click)="selectedOptionsChanged(opt,'single')" color="primary" slot="start" value="{{opt}}">
              </ion-radio>
            </ion-item>
          </ion-radio-group>

        </ng-template>
      </ion-list>
    </ion-col>

  </ion-row>
</div>